import { useMatch } from '@tanstack/react-router';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';

// TODO: remove after old alerts page is removed

const useIsThreatsApp = () => {
  const matches = useMatch({ strict: false });
  const { key: entityViewConfigKey } = matches.staticData;
  return !!entityViewConfigKey && [EntityTypeConfigKeys.IncidentThreats, EntityTypeConfigKeys.AlertNew].includes(entityViewConfigKey);
};

export default useIsThreatsApp;
